import api from 'services/api';

/**
 * Lista férias de um funcionário ou da empresa toda.
 */
export async function listarFerias(filtros = {}) {
  const response = await api.get('/dp/ferias', { params: filtros });
  return response.data;
}

/**
 * Busca funcionários com férias vencidas, vencendo ou pendentes.
 * @param {string} status - 'todos' | 'vencida' | 'vencendo' | 'pendente'
 */
export async function buscarVencimentosFerias(status = 'todos') {
  const response = await api.get('/dp/ferias/vencimentos', { params: { status } });
  return response.data;
}

/**
 * Busca a situação de férias de um funcionário específico (todos os períodos).
 */
export async function buscarSituacaoFeriasFuncionario(funcionarioId) {
  const response = await api.get(`/dp/funcionarios/${funcionarioId}/situacao-ferias`);
  return response.data;
}
